import { Api } from '@axiom/ui';
import type { AhqSubmission } from '@axiom/validation';

import ApiHelper from '../lib/api-helper';
import { EnvUtil } from '../utils/env-util';

const api = new ApiHelper('SUBMISSIONS');

class SubmissionsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  readSubmissionDetails(submissionId: string) {
    return super.read<{ data: AhqSubmission }>({
      endpoint: `/submissions/${submissionId}`,
      method: 'GET',
    });
  }
}

export const SubmissionsApi = new SubmissionsApiClass();

export const getSubmission = async (submissionId: string) => {
  const { data } = await api.GET(
    `${EnvUtil.apiPortalUrl}/submissions/${submissionId}`
  );
  return data;
};
